import { IPackage } from '../models.interfaces/package.model.interface';

export class EmptyPackage implements IPackage {
    id = -1;
    nom = '';
    ht: number;
    quantite: null;
}
